import React from 'react';
import Insights from './Insights';
import { connect } from 'react-redux';
import { fetchInsightsWidgetData } from '../../../../dataFetchers/insightsDataFetcher';

class InsightsContainer extends React.Component {

  componentDidMount(){
    if(!this.props.insights){
      this.props.fetchInsights(this.props.userId, {
        title: this.props.translations.data["HOME.INSIGHTS.DUMMY_DATA.TITLE"],
        description: this.props.translations.data["HOME.INSIGHTS.DUMMY_DATA.DESCRIPTION"]
      }, this.props.configs.data["date_format"]);
    }
  }

  render(){
    return(
      <>
        {this.props.insights && <Insights insights={this.props.insights.insightList} translations={this.props.translations.data} insightListError={this.props.insights.insightListError} userId={this.props.userId} />}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId : state.userIdentityDetails.userId,
    insights: state.insights,
    translations: state.translationsData,
    configs: state.configs
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchInsights: (uuid, translations, dateFormat) => {dispatch(fetchInsightsWidgetData(uuid, translations, dateFormat))}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InsightsContainer);
